import TurnusStore from 'src/stores/TurnusStore';
import KlientStore from 'src/stores/KlientStore';
import DenStore from 'src/stores/DenStore';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Grid, Drawer, AppBar, Toolbar, IconButton, FormControl, InputLabel, Table, Select, MenuItem, TableHead, TableRow, TableCell, TableBody, Typography, TextField, Paper, List, ListItem, ListItemText, ListItemIcon, Fab, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';
import { computed, observable, action } from 'mobx';
import NavigationDrawerItems from './NavigationDrawerItems';
import MenuIcon from '@material-ui/icons/Menu';
import { inject, observer } from 'mobx-react';
import 'src/assets/styles/index.css'
import DoneIcon from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import AddIcon from '@material-ui/icons/Add';
import 'moment/locale/cs';
import Objednavka from 'src/models/Objednavka';
import ObjednavkaStore from 'src/stores/ObjednavkaStore';
import Klient from 'src/models/Klient';
import Turnus from 'src/models/Turnus';
import { OrderHelper } from 'src/classes/OrderHelper';
import HistoryListing from 'src/components/HistoryListing';
import HistorieStore from 'src/stores/HistorieStore';
import FakturaceStore from 'src/stores/FakturaceStore';
import Faktura from 'src/models/Faktura';
import CiselnikyStore from 'src/stores/CiselnikyStore';
import AuthStore from 'src/stores/AuthStore';

export interface IOrderDetailProps extends RouteComponentProps<any> {
    klientStore?: KlientStore;
    turnusStore?: TurnusStore;
    denStore?: DenStore;
    objednavkaStore?: ObjednavkaStore;
    historieStore?: HistorieStore;
    fakturaceStore?: FakturaceStore;
    objednavkaId: number;
    ciselnikyStore?: CiselnikyStore;
    authStore?: AuthStore;
}

@inject('klientStore')
@inject('authStore')
@inject('fakturaceStore')
@inject('objednavkaStore')
@inject('turnusStore')
@inject('denStore')
@inject('historieStore')
@inject('ciselnikyStore')
@observer
class OrderDetail extends React.Component<IOrderDetailProps>{

    constructor(props: Readonly<IOrderDetailProps>) {
        super(props);
        console.log("LOAD: OrderDetail/" + props.objednavkaId);
        this.props.fakturaceStore.getInvoicesForOrder(this.props.objednavkaId)
            .then(list => {
                this.invoices = list;
            });
    }

    // Other stuff
    @observable private isDrawerOpened: boolean = false;
    @observable private isHistoryDialogOpen: boolean = false;
    @observable private isDeleteDialogOpened: boolean = false;
    @observable private dirty: boolean = false;
    
    @observable private invoices: Faktura[] = [];
    private orderBacking: Objednavka = null;
    private orderOriginal: Objednavka = null;

    @computed private get order(): Objednavka {
        if (!this.orderBacking || (this.orderBacking.id !== this.props.objednavkaId)) {
            this.orderOriginal = this.props.objednavkaStore.getObjednavkaByID(this.props.objednavkaId);
            if(this.orderOriginal) {
                this.orderBacking = this.orderOriginal.clone();
            }
        }
        return this.orderBacking;
    }

    @computed private get clients(): Klient[] {
        const turnusy: Turnus[] = this.props.turnusStore.getTurnusyByObjednavkaID(this.props.objednavkaId);
        const mapa: Map<number, Klient> = new Map();
        turnusy.forEach(trns => {
            mapa.set(trns.idKlient, this.props.klientStore.getClientById(trns.idKlient));
        })
        const retVal: Klient[] = [];
        mapa.forEach(kl => {
            retVal.push(kl);
        })
        return retVal;
    }

    @action
    private handleChange = name => event => {
        this.dirty = true;
        this.order[name] = event.target.value;
    };

    @action
    private drawerMenuClick = event => {
        this.isDrawerOpened = !this.isDrawerOpened;
    }

    private getData(): Map<number, Turnus[]> {
        const retVal: Map<number, Turnus[]> = new Map();
        const turnusy: Turnus[] = this.props.turnusStore.getTurnusyByObjednavkaID(this.props.objednavkaId);
        turnusy.forEach(trns => {
            if(!retVal.has(trns.idKlient)) {
                retVal.set(trns.idKlient, []);
            }
            retVal.get(trns.idKlient).push(trns);
        });
        return retVal;
    }

    private handleDoneClick = event => {
        if(this.dirty) {
            this.props.objednavkaStore.updateOrder(this.orderBacking)
            .then(resp => {
                this.orderOriginal.loadFromEntity(this.orderBacking);
                this.dirty = false;
            });
        }
    }

    private onCloseHistoryDialog = event => {
        this.isHistoryDialogOpen = false;
    }

    private showHistory = event => {
        this.props.historieStore.loadOrderHistory(this.props.objednavkaId).then(success => {
            this.isHistoryDialogOpen = true;
        });
    }

    private getInvoiceStatusLabel(status: string) {
        switch(status) {
            case 'new': return 'Vystavená';
            case 'paid': return 'Zaplacená';
        }
        return 'Neznama hodnota';
    }

    private openInvoice = (link: string) => event => {
        window.open(link, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
    }

    private toInvoicing = event => {
        console.log("OrderDetail.toInvoicing");
        this.props.history.push(`/orders/${this.props.objednavkaId}/invoicing`);
    }

    private toEmail = event => {
        console.log("OrderDetail.toEmail");
        this.props.history.push(`/paymentDetails/${this.props.objednavkaId}`);
    }

    private handleClientDeleteClick = event => {
        this.isDeleteDialogOpened = true;
    }

    @action
    private onCloseDeleteDialog = event => {
        this.isDeleteDialogOpened = !this.isDeleteDialogOpened;
    }

    private handleDeleteDialogOK = event => {
        this.props.objednavkaStore.deleteOrder(this.props.objednavkaId)
            .then(success => {
                this.props.objednavkaStore.removeObjednavkaFromLocalStore(this.props.objednavkaId);
                this.props.turnusStore.removeLocalTurnusesByObjednavkaID(this.props.objednavkaId);
                this.props.history.push(`/orders`);
            })
    }

    public render() {
        return (
            this.order ?
                <div>
                    <Drawer open={this.isDrawerOpened} onClose={this.drawerMenuClick}>
                        <NavigationDrawerItems />
                    </Drawer>
                    <Grid container spacing={8}>
                        <Grid item xs={12}>
                            <AppBar position="static" >
                                <Toolbar>
                                    <IconButton color="inherit" aria-label="Menu" onClick={this.drawerMenuClick}>
                                        <MenuIcon />
                                    </IconButton>
                                    <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                        Objednávka - {this.order.id}
                                    </Typography>
                                    {this.props.authStore.hasGUIResource('order-delete') ?
                                    <IconButton color="inherit" aria-label="Delete" onClick={this.handleClientDeleteClick}>
                                        <DeleteIcon />
                                    </IconButton> : '' }
                                    <Button onClick={this.showHistory} color="inherit">
                                        Historie
                                    </Button>
                                    {this.props.authStore.hasGUIResource('create-invoice') ?
                                        <Button onClick={this.toInvoicing} color="inherit">
                                            Na fakturaci
                                        </Button> : '' }
                                    {this.props.authStore.hasGUIResource('send-payment-details') ?
                                        <Button onClick={this.toEmail} color="inherit">
                                            Na platební údaje
                                        </Button> : '' }
                                </Toolbar>
                            </AppBar>
                        </Grid>

                        <Grid item xs={12} style={{ margin: 8 }}>
                            <Grid container spacing={8}>
                                <Grid item xs={6}>
                                    <Paper square>
                                        <AppBar position="static" color="secondary" style={{ boxShadow: 'none', backgroundColor: '#90a4ae'}}>
                                            <Toolbar variant="dense">
                                            <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                                Základní údaje
                                            </Typography>
                                            <IconButton color="inherit" aria-label="Done" onClick={this.handleDoneClick}>
                                                { !this.dirty ? <DoneIcon /> : <SaveIcon /> }
                                            </IconButton>
                                            </Toolbar>
                                        </AppBar>
                                        <Grid container spacing={8} style={{ marginLeft: 8, marginTop: 10 }}>
                                            <Grid container className="default-margin" spacing={8}>
                                                <Grid item xs={2}>
                                                    <TextField disabled={!this.props.authStore.hasGUIResource('order-change-state')} label="Stav" id="order-state" select onChange={this.handleChange('stav')} 
                                                        value={this.order.stav}>
                                                                <MenuItem value="novy">{OrderHelper.prettyPrintState('novy')}</MenuItem>
                                                                <MenuItem value="odeslany">{OrderHelper.prettyPrintState('odeslany')}</MenuItem>
                                                                <MenuItem value="zaplaceny">{OrderHelper.prettyPrintState('zaplaceny')}</MenuItem>
                                                    </TextField>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={6}>
                                    <Paper square>
                                        <AppBar position="static" color="secondary" style={{ boxShadow: 'none', backgroundColor: '#90a4ae'}}>
                                            <Toolbar variant="dense">
                                            <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                                Fakturace
                                            </Typography>
                                            </Toolbar>
                                        </AppBar>
                                        <Grid container spacing={8}>
                                            <Grid item xs={12} style={{ margin: 8 }}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Číslo faktury</TableCell>
                                                            <TableCell>Subjekt</TableCell>
                                                            <TableCell>Cena</TableCell>
                                                            <TableCell>Stav</TableCell>
                                                            <TableCell />
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.invoices.map(faktura => (
                                                            <TableRow hover key={faktura.id}>
                                                                <TableCell>{faktura.number}</TableCell>
                                                                <TableCell>{this.props.fakturaceStore.getSubjectByFakturoidID(faktura.idSubjekt).name}</TableCell>
                                                                <TableCell>{faktura.price} Kč</TableCell>
                                                                <TableCell>{this.getInvoiceStatusLabel(faktura.status)}</TableCell>
                                                                <TableCell><Button onClick={this.openInvoice(faktura.publicLink)}>Fakturoid</Button></TableCell>
                                                            </TableRow>
                                                            ))
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12} style={{ margin: 8 }}>
                            {this.clients.map(kl => (
                            <Grid item xs={12} style={{ marginBottom: 20 }}>
                                <Paper square>
                                    <AppBar position="static" color="secondary" style={{ boxShadow: 'none', backgroundColor: '#8390c8'}}>
                                        <Toolbar variant="dense">
                                        <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                            Klient - {kl.jmeno + ' ' + kl.prijmeni}
                                        </Typography>
                                        </Toolbar>
                                    </AppBar>
                                    <Grid container spacing={8} style={{ marginTop: 10 }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Od - do</TableCell>
                                                    <TableCell>Program</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.getData().get(kl.id).map(turnus => (
                                                    <TableRow hover key={turnus.id}>
                                                        <TableCell>{turnus.od.toLocaleDateString() + " - " + turnus.do.toLocaleDateString()}</TableCell>
                                                        <TableCell>{this.props.ciselnikyStore.getProgramByID(turnus.program).value} kJ</TableCell>
                                                    </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </Grid>
                                </Paper>
                            </Grid>
                            ))}
                        </Grid>
                    </Grid>
                    <Dialog
                        open={this.isDeleteDialogOpened}
                        onClose={this.onCloseDeleteDialog}
                        aria-labelledby="delete-confirm-dialog">
                        <DialogTitle id="delete-confirm-dialog">Smazat</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Opravdu si přejete SMAZAT objednávku?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onCloseDeleteDialog} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={this.handleDeleteDialogOK} color="primary">
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={this.isHistoryDialogOpen}
                        onClose={this.onCloseHistoryDialog}
                        aria-labelledby="history-dialog"
                        maxWidth="md"
                        fullWidth>
                        <DialogTitle id="history-dialog">Historie</DialogTitle>
                        <DialogContent>
                            <HistoryListing />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onCloseHistoryDialog} color="primary">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                : <Typography variant="h5">Nenalezen</Typography>
        )
    }
}

export default withRouter(OrderDetail)



// WEBPACK FOOTER //
// ./src/components/OrderDetail.tsx